import React from 'react';
import { Loader } from '@trackman/web-shared-components';
import { OverlayWrapper } from './OverlayStyles';

interface IProps {
  hasSpinner: boolean;
  top?: string;
  onClickCallback?: () => void;
  onMouseDownCallback?: () => void;
}

const Overlay: React.FC<IProps> = ({ hasSpinner, top, onClickCallback, onMouseDownCallback }) => {
  return (
    <OverlayWrapper onMouseDown={onMouseDownCallback && onMouseDownCallback} onClick={onClickCallback && onClickCallback} style={{ top }}>
      {hasSpinner && <Loader size='large' />}
    </OverlayWrapper>
  );
};

Overlay.defaultProps = {
  top: '0px',
} as Partial<IProps>;

export default Overlay;
